const NawyNowMapFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M19.7901 4.22031C16.8301 1.27031 12.0301 1.27031 9.09015 4.22031C7.02015 6.27031 6.40015 9.22031 7.20015 11.8203L2.50015 16.5203C2.17015 16.8603 1.94015 17.5303 2.01015 18.0103L2.31015 20.1903C2.42015 20.9103 3.09015 21.5903 3.81015 21.6903L5.99015 21.9903C6.47015 22.0603 7.14015 21.8403 7.48015 21.4903L8.30015 20.6703C8.50015 20.4803 8.50015 20.1603 8.30015 19.9603L6.36015 18.0203C6.07015 17.7303 6.07015 17.2503 6.36015 16.9603C6.65015 16.6703 7.13015 16.6703 7.42015 16.9603L9.37015 18.9103C9.56015 19.1003 9.88015 19.1003 10.0701 18.9103L12.1901 16.8003C14.7801 17.6103 17.7301 16.9803 19.7901 14.9303C22.7401 11.9803 22.7401 7.17031 19.7901 4.22031ZM14.5001 12.0003C13.1201 12.0003 12.0001 10.8803 12.0001 9.50031C12.0001 8.12031 13.1201 7.00031 14.5001 7.00031C15.8801 7.00031 17.0001 8.12031 17.0001 9.50031C17.0001 10.8803 15.8801 12.0003 14.5001 12.0003Z"
        fill="#FF5E00"
      />
      <path
        d="M14.5 12C15.8807 12 17 10.8807 17 9.5C17 8.11929 15.8807 7 14.5 7C13.1193 7 12 8.11929 12 9.5C12 10.8807 13.1193 12 14.5 12Z"
        fill="#FF5E00"
      />
    </svg>
  );
};

export default NawyNowMapFilterIcon;
